import Vue from "vue";
import { formatCurrency } from '@/lib/Currencies';
Vue.filter("currency", formatCurrency);
